import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import { HeadingArticle } from '../design-system/Headings';
import RichText, { SecondaryRenderer } from '../design-system/RichText';
import { Form, Field, Submit } from '../design-system/Forms';
import { LinkButton } from '../design-system/Buttons';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

import phrasesType from '../proptypes/phrases';
import staticPageType from '../proptypes/static-page';
import formType from '../proptypes/forms';

const AccessDeniedPage = ({
  phrases,
  content: {
    heading, body, sidePanel,
  },
  linkTicketForm,
  checkoutPath,
}) => (
  <PageWrapper bgDark>
    <RadarHeroPageSection container={false}>
      <Container small>
        <HeadingArticle el="h1" my0>{heading}</HeadingArticle>
      </Container>
    </RadarHeroPageSection>
    <PageSection container={false}>
      <Container small>
        <RichText paragraphRenderer={SecondaryRenderer} content={body} />
        <Form {...linkTicketForm} negativeMargins>
          <Field
            name="scan_code"
            label={phrases.scanCode.label}
            maxLength={10}
          />
          <Submit secondary>{phrases.linkMyTicket}</Submit>
        </Form>
        <RichText paragraphRenderer={SecondaryRenderer} content={sidePanel} />
        <LinkButton w100 secondary href={checkoutPath}>Buy Now</LinkButton>
      </Container>
    </PageSection>
  </PageWrapper>
);

AccessDeniedPage.propTypes = {
  phrases: phrasesType.isRequired,
  linkTicketForm: formType.isRequired,
  checkoutPath: PropTypes.string.isRequired,
  content: staticPageType.isRequired,
};

export default hot(AccessDeniedPage);
